import Image, { ImageProps } from 'next/legacy/image';
import { decodeAssetId, urlForImage } from '@lib/sanity';

type Props = {
  src: ImageProps; // TODO: remove `any`
  alt?: string;
  height?: any; // TODO: remove `any`
  width?: any; // TODO: remove `any`
  wrapClassName?: string;
  className?: string;
} & any;

export function SaneImage({
  src,
  height,
  width,
  layout,
  wrapClassName,
  ...props
}: Props) {
  const { dimensions, format } = decodeAssetId(src.asset._ref);
  const url = urlForImage(src.asset).url() || '';

  const newHeight = height
    ? height
    : width
    ? (width / dimensions.width) * dimensions.height
    : format === 'svg' || src.lowresolution
    ? dimensions.height
    : dimensions.height / 2;
  const newWidth = width
    ? width
    : height
    ? (height / dimensions.height) * dimensions.width
    : format === 'svg' || src.lowresolution
    ? dimensions.width
    : dimensions.width / 2;

  const customDimensions = layout
    ? { layout }
    : { height: newHeight, width: newWidth };

  return format === 'gif' ? (
    <img src={url} height={newHeight} width={newWidth} alt={src.alt} />
  ) : (
    <div className={wrapClassName || 'image-wrap'}>
      <Image alt={src.alt} {...props} {...customDimensions} src={url} />
    </div>
  );
}

export default SaneImage;
